<template>
  <card :has-settings="false" :has-subtitle="false" title="Video Reason" :auto-height="true" class="video-reason-card">
    <template #content>
      <div class="video-reason-content" v-if="availableVideoReasons.length">
        <input-with-validation
          v-model="selectedVideoReason"
          field-label=" "
          b-name="select"
          expanded>
          <option :value="null">Select video reason</option>
          <option v-for="reason in availableVideoReasons" :value="reason.id" :key="reason.id">
            {{ reason.name }}
          </option>
        </input-with-validation>
      </div>
      <p v-else class="p-4 has-text-centered">Please add or enable at least one video reason</p>
    </template>
    <template #headerUtils>
      <button class="button is-primary is-outlined mr-2" @click="save" v-if="availableVideoReasons.length">Save</button>
      <slot name="headerUtils"></slot>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card.vue"
import InputWithValidation from "@/components/validation/InputWithValidation.vue"
import to from "@/lib/to"

export default {
  name: "VideoReasonCard",
  components: { Card, InputWithValidation },
  props: {
    meetingId: {
      type: Number,
      required: true
    }
  },
  async mounted() {
    await Promise.all([
      this.fetchVideoReasons(),
      this.fetchMeeting()
    ])
  },
  methods: {
    async fetchVideoReasons() {
      const [err, response] = await to(this.$http.get('/video_reasons/dropdown'))
      if (!err) {
        this.availableVideoReasons = response.data
      }
    },
    async fetchMeeting() {
      const [err, response] = await to(this.$http.get(`/meetings/${this.meetingId}`))
      if (!err && response.data.results && response.data.results.length > 0) {
        const meeting = response.data.results[0]
        if (meeting.video_reasons && meeting.video_reasons.length > 0) {
          this.selectedVideoReason = meeting.video_reasons[0].id
        }
      }
    },
    async save() {
      if (!this.selectedVideoReason) {
        return
      }

      this.saving = true
      const [err] = await to(this.$http.put(`/meetings/${this.meetingId}/video_reason`, {
        video_reason_id: this.selectedVideoReason
      }))

      this.saving = false

      if (!err) {
        this.$buefy.toast.open({
          message: 'Video reason updated successfully',
          type: 'is-success'
        })
      } else {
        this.$buefy.toast.open({
          message: 'Failed to update video reason',
          type: 'is-danger'
        })
      }
    }
  },
  data() {
    return {
      availableVideoReasons: [],
      selectedVideoReason: null,
      saving: false
    }
  }
}
</script>
